import { useContext } from "react";

import { useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";
import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const mutationFactory = () => {
  const query = `mutation removeNextWorkflowFromConditionsGroup($nextWorkflowId: ID!) {
        removeNextWorkflowFromConditionsGroup(nextWorkflowId: $nextWorkflowId) {
          successMessage
        }
    }`;

  const resolver = ({ data: { removeNextWorkflowFromConditionsGroup } }) => {
    return { data: removeNextWorkflowFromConditionsGroup };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

export function useRemoveNextWorkflowFromConditionsGroupAction() {
  const mutate = useMutation(mutationFactory);
  const { fireError } = useContext(ToasterContext);

  return (nextWorkflowId) => {
    return mutate({
      nextWorkflowId: toGlobalId("NextWorkflow", nextWorkflowId),
    })
      .then((resp) => {
        return resp;
      })
      .catch((e) => {
        fireError(
          Array.isArray(e) && e[0]?.message
            ? e[0].message
            : "Failed to removes next workflow from conditions group, please retry or contact support for assistance",
          e
        );
      });
  };
}

export default useRemoveNextWorkflowFromConditionsGroupAction;
